module.exports = __webpack_public_path__ + "img/tanzania-logo-icon.f9e82f74.png";